// 작업자 호소의 [대응조치 등록/수정] 버튼이 공용 모달을 prefill 후 open 시키는 Stimulus 컨트롤러
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  open(event) {
    const button = event.currentTarget
    const complaintId = button.dataset.complaintId
    const existing = button.dataset.existingValue || ""

    const modal = document.getElementById("corrective-action-modal")
    if (!modal) return

    const idField = modal.querySelector('input[name="complaint_id"]')
    const textarea = modal.querySelector('textarea[name="corrective_action"]')
    if (idField) idField.value = complaintId
    if (textarea) textarea.value = existing

    // 이전 검증 실패로 남은 빨간 테두리 / 패딩 제거 — 모달 새로 열 때 깔끔하게
    modal.querySelectorAll('[data-usage-info-required-target="field"]').forEach((row) => {
      row.classList.remove("!border", "!border-[var(--danger-500)]", "!bg-[var(--danger-50)]", "!rounded-md", "!p-3")
    })

    modal.dispatchEvent(new CustomEvent("modal:open"))
  }
}
